module.exports = __webpack_public_path__ + "static/media/MICROBES_LOW_BR.89483a7a.mp4";